/// <reference types="vite/types/importMeta.d.ts" />

import { UserAccessEnum } from "../models/user.access"
import { authService, AuthService } from "./auth-service"

interface HTTPService {
  query(url: string, method: string, body?: any): Promise<any>
}

class HTTPServiceBase implements HTTPService {
  private readonly PARTIAL_CONTENT_STATUS = 206
  private headers: Headers
  constructor(private authService: AuthService, private endpointUrl: string, token?: string) {
    this.headers = new Headers()
    if (token) this.authenticate(token)
  }

  authenticate(token: string | null) {
    token ? this.headers.set('Authorization', `Bearer ${token}`) : this.headers.delete('Authorization')
  }

  async query(url: string, method: string, body: any) {
    this.authenticate(localStorage.getItem('tbw-auth-infos'))
    try {
      const response = await fetch(this.endpointUrl + url, { method, body, headers: this.headers })
      if (!response.ok) { throw new Error(await response.text()) }
      // TODO: remove this WORKAROUND when unicity is possible
      // it sets hardly user access state following the response
      this.userAccessIntercepter(response)
      return await response.json()
    } catch (e) {
      console.error(e)
      return Promise.resolve([])
    }
  }

  private userAccessIntercepter(response: Response): void {
    const userAccess: UserAccessEnum = this.isPartialResponse(response) ? UserAccessEnum.FREEMIUM : UserAccessEnum.PREMIUM
    this.authService.currentUser = { userAccess }
  }

  private isPartialResponse(response: Response): boolean {
    return response.status === this.PARTIAL_CONTENT_STATUS
  }
}

const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT
const httpService = new HTTPServiceBase(authService, API_ENDPOINT)

export { httpService, HTTPService }